var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lmb-table"},[_c('div',{staticClass:"table-content"},[_c('q-table',{attrs:{"data":_vm.listData.slice(
          (_vm.currentPage - 1) * _vm.pageSize,
          _vm.currentPage * _vm.pageSize
        ),"header-cell-style":{
        'text-align': 'center',
        'border-color': '#465ECC',
      },"cell-style":{
        color: '#5891FA',
        'font-size': '16px',
        'text-align': 'center',
        'border-color': '#465ECC',
      }}},[_c('q-table-column',{attrs:{"prop":"index","label":"序号","width":"50"}}),(_vm.isType === 1)?_c('q-table-column',{attrs:{"prop":"awards","label":"奖项","width":"150"}}):_vm._e(),_c('q-table-column',{attrs:{"width":_vm.isType === 1 ? '200' : '300',"prop":"id","label":"战队名称"}}),_c('q-table-column',{attrs:{"prop":"name","label":"战队所属学校"}})],1)],1),_c('q-pagination',{attrs:{"background":"","layout":"pager","current-page":_vm.currentPage,"page-size":_vm.pageSize,"total":_vm.total},on:{"update:currentPage":function($event){_vm.currentPage=$event},"update:current-page":function($event){_vm.currentPage=$event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }